"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOVE_USER_SUCCESS = exports.MOVE_USER_FAILED = exports.MOVE_USER_REQUEST = exports.TOGGLE_MOVE_USER_MODAL = exports.REMOVE_USER_FAILED = exports.REMOVE_USER_SUCCESS = exports.REMOVE_USER_REQUEST = exports.REMOVE_GROUP_FAILED = exports.REMOVE_GROUP_SUCCESS = exports.REMOVE_GROUP_REQUEST = exports.CREATE_EDIT_FAILED = exports.CREATE_EDIT_SUCCESS = exports.CREATE_EDIT_REQUEST = exports.CREATE_EDIT_GROUP_MODAL = exports.CLEAR_STATE = void 0;
//#region List
exports.CLEAR_STATE = '@sok/customer/user_groups/CLEAR_STATE';
//#region Group
exports.CREATE_EDIT_GROUP_MODAL = '@sok/customer/user_groups/CREATE_EDIT_GROUP_MODAL';
exports.CREATE_EDIT_REQUEST = '@sok/customer/user_groups/CREATE_EDIT_REQUEST';
exports.CREATE_EDIT_SUCCESS = '@sok/customer/user_groups/CREATE_EDIT_SUCCESS';
exports.CREATE_EDIT_FAILED = '@sok/customer/user_groups/CREATE_EDIT_FAILED';
// Remove groups
exports.REMOVE_GROUP_REQUEST = '@sok/customer/user_groups/REMOVE_GROUP_REQUEST';
exports.REMOVE_GROUP_SUCCESS = '@sok/customer/user_groups/REMOVE_GROUP_SUCCESS';
exports.REMOVE_GROUP_FAILED = '@sok/customer/user_groups/REMOVE_GROUP_FAILED';
// Remove users
exports.REMOVE_USER_REQUEST = '@sok/customer/user_groups/REMOVE_USER_REQUEST';
exports.REMOVE_USER_SUCCESS = '@sok/customer/user_groups/REMOVE_USER_SUCCESS';
exports.REMOVE_USER_FAILED = '@sok/customer/user_groups/REMOVE_USER_FAILED';
// Move users
exports.TOGGLE_MOVE_USER_MODAL = '@sok/customer/user_groups/TOGGLE_MOVE_USER_MODAL';
exports.MOVE_USER_REQUEST = '@sok/customer/user_groups/MOVE_USER_REQUEST';
exports.MOVE_USER_FAILED = '@sok/customer/user_groups/MOVE_USER_FAILED';
exports.MOVE_USER_SUCCESS = '@sok/customer/user_groups/MOVE_USER_SUCCESS';
//# sourceMappingURL=userGroups.js.map